export default function isValidIso8601DateFormat(value: any): boolean {
  const regexp = new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/);

  return regexp.test(String(value));
}
